<template>
  <div class="pollution-bie" ref="bie"></div>
</template>

<script>
import * as echarts from 'echarts';

const defaultData = [
  {
    value: 235,
    name: '工业企业',
    nubmber: 25,
    change: '2↓',
    proportion: '100%',
  },
  {
    value: 345,
    name: '污水处理厂',
    nubmber: 25,
    change: '2↓',
    proportion: '100%',
  },
  {
    value: 629,
    name: '禽畜养殖',
    nubmber: 25,
    change: '2↓',
    proportion: '100%',
  },
  {
    value: 582,
    name: '水产养殖',
    nubmber: 25,
    change: '2↓',
    proportion: '100%',
  },
];
export default {
  data() {
    return {
      myChart: {},
    };
  },
  methods: {
    initChart(data = defaultData) {
      const option = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}%',
        },
        legend: {
          right: 0,
          left: 230,
          top: 50,
          bottom: 20,
          orient: "vertical", // 垂直方向
          textStyle: {
            color: "#fff",
          },
          selectedMode: false,
        },
        series: [
          {
            label: {
              show: false,
            },
            name: '污染占比',
            type: 'pie',
            radius: '75%',
            center: ['22%', '50%'],
            data,
            itemStyle: {
              normal: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0,0,0,0.5)',
                color: (params) => {
                  const colorList = [
                    {
                      c1: '#30e3ea',
                      c2: '#3b6e6a',
                    },
                    {
                      c1: '#08d3a9',
                      c2: '#36675d',
                    },
                    {
                      c1: '#8ac7bc',
                      c2: '#7aa79f',
                    },
                    {
                      c1: '#E78458',
                      c2: '#655047',
                    },
                    {
                      c1: 'rgba(103,118,255,0.6)',
                      c2: '#4a4d6b',
                    },
                    {
                      c1: '#e6a23c',
                      c2: '#eebe77',
                    },
                    {
                      c1: '#409eff',
                      c2: '#79bbff',
                    },
                  ];
                  return colorList[params.dataIndex].c1;
                },
              },
            },
          },
          // {
          //   name: '外边框',
          //   type: 'pie',
          //   clockWise: false,
          //   radius: ['74%', '74%'],
          //   center: ['22%', '50%'],
          // },
        ],
      };
      this.$nextTick(() => {
        this.myChart.setOption(option);
      });
    },
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.bie);
  },
};
</script>

<style lang="scss" scoped>
.pollution-bie {
  width: 450px;
  height: 260px;
  margin-top: 0.8rem;
}
</style>
